import { useState, useEffect } from 'react'
import { api, Product } from '@/services/api'

interface UseProductsOptions {
  category?: string
  sort?: string
  order?: string
}

export function useProducts(options: UseProductsOptions = {}) {
  const { category, sort, order } = options
  const [products, setProducts] = useState<Product[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true)
      setError(null)

      try {
        const response = await api.getProducts({ category, sort, order })
        setProducts(response.products)
      } catch (err) {
        setError('Failed to fetch products')
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    fetchProducts()
  }, [category, sort, order])

  return { products, loading, error }
}
